import { WORK_MANAGEMENT_MINI_SITE_LINK, CRM_MINI_SITE_LINK, SOFTWARE_MINI_SITE_LINK, SERVICE_MINI_SITE_LINK, CANVAS_HOMEPAGE_LINK, CAMPAIGNS_MINI_SITE_LINK, MONDAY_VIBE_LINK, MONDAY_MAGIC_LINK, MONDAY_AGENT_FACTORY_LINK } from "constants/links";
export const MAIN_PRODUCTS = [
    {
        name: "header.tabs.solutions.byProduct.workManagement",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/WM.svg",
        miniSiteLink: WORK_MANAGEMENT_MINI_SITE_LINK,
        productStoreLink: "monday.com/account_products/direct_install/core"
    },
    {
        name: "header.tabs.solutions.byProduct.crm",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/CRM.svg",
        miniSiteLink: CRM_MINI_SITE_LINK,
        productStoreLink: "monday.com/account_products/direct_install/crm"
    },
    {
        name: "header.tabs.solutions.byProduct.dev",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/DEV.svg",
        miniSiteLink: SOFTWARE_MINI_SITE_LINK,
        productStoreLink: "monday.com/account_products/direct_install/software"
    },
    {
        name: "header.tabs.solutions.byProduct.campaigns",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/monday-crm/assets/email-marketing-project/campaigns-logo-square.png",
        miniSiteLink: CAMPAIGNS_MINI_SITE_LINK,
        productStoreLink: "monday.com/account_products/direct_install/marketing_campaigns"
    },
    {
        name: "header.tabs.solutions.byProduct.service",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/SVC.svg",
        miniSiteLink: SERVICE_MINI_SITE_LINK,
        productStoreLink: "monday.com/account_products/direct_install/service"
    }
];
export const ADDITIONAL_PRODUCTS = [
    {
        name: "Agent Factory",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/Switcher%20icons/agent_factory.svg",
        miniSiteLink: MONDAY_AGENT_FACTORY_LINK
    },
    {
        name: "WorkCanvas",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/canvas.png",
        miniSiteLink: CANVAS_HOMEPAGE_LINK
    }
];
export const AI_SOLUTIONS = [
    {
        name: "Magic",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/Switcher%20icons/magic.svg",
        miniSiteLink: MONDAY_MAGIC_LINK
    },
    {
        name: "Vibe",
        iconLink: "https://dapulse-res.cloudinary.com/image/upload/Switcher%20icons/vibe.svg",
        miniSiteLink: MONDAY_VIBE_LINK,
        hasComingSoonTag: true
    }
];
